import React, { Component, Fragment, useState } from "react";
import { Form, Accordion, Card } from "react-bootstrap";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import CheckBoxChecked from "../../images/check_box_checked.svg";
import CheckBoxUnCheck from "../../images/check_box_uncheck.svg";
import { HEALTH_CHECK } from "../../data/locale";
import SelectComponent from "../Select";
import { SpaceBox } from "../Space";
import { INSURED_AMOUNT, DISEASE, DISABILITY } from "../../data/personal";
import "./checkbox.scss";

export default class CheckBoxHealth extends Component {
  state = {
    isToggle: false,
    checked: false,
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false
  };

  constructor(props) {
    super(props);
    this.state.checked = props.checked;
    this.state.checked1 = props.checked1;
    this.state.checked2 = props.checked2;
    this.state.checked3 = props.checked3;
    this.state.checked4 = props.checked4;
    this.state.checked5 = props.checked5;
    // this.state.select = props.select;
  }

  _onCheckFirst = () => {
    const { checked1 } = this.state;
    const { onCheckFirst } = this.props;
    const { onCheckChange } = this.props;
    const next = !checked1;
    this.setState({ ...this.state, checked1: next }, res => {
      if (onCheckFirst) {
        onCheckFirst(next);
      }
    });
  };

  _onCheckSecond = () => {
    const { checked2 } = this.state;
    const { onCheckSecond } = this.props;
    const next = !checked2;

    this.setState({ ...this.state, checked2: next }, res => {
      if (onCheckSecond) {
        onCheckSecond(next);
      }
    });
  };

  _onCheckThird = () => {
    const { checked3 } = this.state;
    const { onCheckThird } = this.props;
    const next = !checked3;

    this.setState({ ...this.state, checked3: next }, res => {
      if (onCheckThird) {
        onCheckThird(next);
      }
    });
  };

  _onCheckForth = () => {
    const { checked4 } = this.state;
    const { onCheckForth } = this.props;
    const next = !checked4;

    this.setState({ ...this.state, checked4: next }, res => {
      if (onCheckForth) {
        onCheckForth(next);
      }
    });
  };

  onChangeModel = ({ name, value }) => {
    const { select } = this.state;
    select[name] = value;
    this.setState({ ...this.state, select });
  };

  _onCheckFifth = () => {
    const { checked5 } = this.state;
    const { onCheckFifth } = this.props;
    const next = !checked5;

    this.setState({ ...this.state, checked5: next }, res => {
      if (onCheckFifth) {
        onCheckFifth(next);
      }
    });
  };

  render() {
    const {
      checked,
      checked1,
      checked2,
      checked3,
      checked4,
      checked5
    } = this.state;
    const imgSource1 = checked1 ? CheckBoxChecked : CheckBoxUnCheck;
    const imgSource2 = checked2 ? CheckBoxChecked : CheckBoxUnCheck;
    const imgSource3 = checked3 ? CheckBoxChecked : CheckBoxUnCheck;
    const imgSource4 = checked4 ? CheckBoxChecked : CheckBoxUnCheck;
    const imgSource5 = checked5 ? CheckBoxChecked : CheckBoxUnCheck;
    const { select } = this.state;
    // const { companyName, addictive, select2, select3 } = select;
    const {
      Answer1_1,
      Answer1_2,
      Answer3,
      Answer4,
      Answer5,
      onChange,
      options
    } = this.props;

    const {
      select1 = "Answer1_1",
      select2 = "Answer1_2",
      select3 = "Answer3",
      select4 = "Answer4",
      select5 = "Answer5"
    } = options || {};

    return (
      <Fragment>
        <div className="form-group">
          <div className="checkbox-wrapper">
            <div className="d-flex">
              <div className="d-flex" onClick={this._onCheckFirst}>
                <img
                  src={imgSource1}
                  className="mr-2"
                  width="24px"
                  height="24px"
                />
                <p className="w-90">
                  คุณมีประกันภัยอุบัติเหตุส่วนบุคคลหรือประกันชีวิตไว้กับบริษัทเมืองไทยประกันภัย
                  และ/หรือ บริษัทอื่น
                </p>
              </div>
            </div>
          </div>
        </div>
        {checked1 ? (
          <Fragment>
            <div className="form-group d-flex">
              <div className="w-50">
                <input
                  type="text"
                  className="form-control"
                  placeholder="ชื่อบริษัท"
                  name="Answer1_1"
                  value={Answer1_1}
                  onChange={e =>
                    onChange({
                      name: e.target.name,
                      value: e.target.value
                    })
                  }
                />
              </div>
              <SpaceBox />
              <div className="w-50">
                <SelectComponent
                  placeholder="ระบุทุนประกัน"
                  options={INSURED_AMOUNT}
                  selected={Answer1_2}
                  onChange={selected =>
                    onChange({ name: select2, value: selected })
                  }
                />
              </div>
            </div>
          </Fragment>
        ) : (
          ""
        )}

        <div className="form-group">
          <div className="checkbox-wrapper">
            <div className="d-flex">
              <div className="d-flex" onClick={this._onCheckSecond}>
                <img
                  src={imgSource2}
                  className="mr-2"
                  width="24px"
                  height="24px"
                />
                <p className="w-90">
                  คุณเคยถูกปฏิเสธการขอเอาประกันชีวิต,
                  การขอเอาประกันภัยอุบัติเหตุส่วนบุคคลหรือ, การต่ออายุสัญญา
                  หรือถูกเรียกเก็บเบี้ยประกันเพิ่มสำหรับการประกันภัยดังกล่าว
                </p>{" "}
              </div>
            </div>
          </div>
        </div>
        <div className="form-group">
          <div className="checkbox-wrapper">
            <div className="d-flex">
              <div className="d-flex" onClick={this._onCheckThird}>
                <img
                  src={imgSource3}
                  className="mr-2"
                  width="24px"
                  height="24px"
                />
                <p className="w-90">
                  คุณเคยใช้สารเสพติดให้โทษ
                  หรือดื่มเครื่องดื่มที่มีแอลกอฮอล์เป็นประจำ
                  หรือเคยได้รับการรักษาเกี่ยวกับโรคดังกล่าว
                </p>{" "}
              </div>
            </div>
          </div>
        </div>
        {checked3 ? (
          <div className="form-group mb-0">
            <input
              type="text"
              className="form-control"
              placeholder="โปรดระบุ"
              name="Answer3"
              value={Answer3}
              onChange={e =>
                onChange({
                  name: e.target.name,
                  value: e.target.value
                })
              }
            />
          </div>
        ) : (
          ""
        )}

        {/* Question */}
        <div className="form-wrapper form-group pl-0">
          <p className="mb-0 font-weight-bold">
            คุณเป็นหรือเคยได้รับการรักษาโรคหรืออาการผิดปกติทางร่างกายต่อไปนี้
          </p>
        </div>
        {/* End-Question */}
        <div className="form-group">
          <div className="checkbox-wrapper">
            <div className="d-flex">
              <div className="d-flex" onClick={this._onCheckForth}>
                <img
                  src={imgSource4}
                  className="mr-2"
                  width="24px"
                  height="24px"
                />
                <p className="w-90">
                  โรคลมชัก, โรคหัวใจ, โรคความดันโลหิตสูง, โรคเบาหวาน,
                  โรคกระดูกและ / หรือกล้ามเนื้อ, โรคมะเร็ง, โรคเอดส์
                </p>{" "}
              </div>
            </div>
          </div>
        </div>
        {checked4 ? (
          <div className="form-group">
            <SelectComponent
              placeholder="โปรดเลือก"
              options={DISEASE}
              selected={Answer4}
              onChange={selected =>
                onChange({ name: select4, value: selected })
              }
            />
          </div>
        ) : (
          ""
        )}

        <div className="form-group">
          <div className="checkbox-wrapper">
            <div className="d-flex">
              <div className="d-flex" onClick={this._onCheckFifth}>
                <img
                  src={imgSource5}
                  className="mr-2"
                  width="24px"
                  height="24px"
                />
                <p className="w-90">
                  อวัยวะพิการ, ความสามารถในการมองเห็น, ความสามารถในการได้ยิน,
                  ความผิดปกติของร่างกายที่ได้รับผลกระทบจากอุบัติเหตุ
                </p>{" "}
              </div>
            </div>
          </div>
        </div>

        {checked5 ? (
          <div className="form-group">
            <SelectComponent
              placeholder="โปรดเลือก"
              options={DISABILITY}
              selected={Answer5}
              onChange={selected =>
                onChange({ name: select5, value: selected })
              }
            />
          </div>
        ) : (
          ""
        )}
      </Fragment>
    );
  }
}
